import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { LocationIcon, HomeIcon, ImageIcon } from '../components/Icons/Icons';
import './SellProperty.css';

function SellProperty() {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    propertyType: '',
    purpose: 'sell',
    title: '',
    price: '',
    location: '',
    city: '',
    area: '',
    areaUnit: 'sqft',
    bedrooms: '',
    bathrooms: '',
    description: '',
    features: [],
    contactName: '',
    contactPhone: '',
    contactEmail: ''
  });

  const steps = [
    { id: 1, title: 'Property Details', icon: <HomeIcon size={24} color="currentColor" /> },
    { id: 2, title: 'Location & Size', icon: <LocationIcon size={24} color="currentColor" /> },
    { id: 3, title: 'Features & Photos', icon: <ImageIcon size={24} color="currentColor" /> },
    { id: 4, title: 'Contact Info', icon: <HomeIcon size={24} color="currentColor" /> }
  ];

  const propertyTypes = ['House', 'Flat', 'Plot', 'Commercial', 'Farmhouse', 'Penthouse'];
  const cities = ['Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan'];
  const features = ['Parking', 'Garden', 'Swimming Pool', 'Gym', 'Security', 'Elevator', 'Balcony', 'Central Heating', 'Central AC'];

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleFeatureToggle = (feature) => {
    const features = formData.features.includes(feature)
      ? formData.features.filter(f => f !== feature)
      : [...formData.features, feature];
    setFormData({ ...formData, features });
  };

  const handleSubmit = () => {
    alert('Property listing submitted successfully! (Mock submission)');
    console.log('Form Data:', formData);
  };

  const nextStep = () => {
    if (currentStep < 4) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  return (
    <div className="sell-property-page">
      <Header />

      <div className="sell-property-container">
        <div className="sell-hero">
          <h1>List Your Property</h1>
          <p>Reach thousands of buyers and sell faster with PakMilkiyat</p>
        </div>

        <div className="sell-content">
          <div className="progress-steps">
            {steps.map((step, index) => (
              <div
                key={step.id}
                className={`step ${currentStep === step.id ? 'active' : ''} ${currentStep > step.id ? 'completed' : ''}`}
              >
                <div className="step-icon">{step.icon}</div>
                <div className="step-text">
                  <div className="step-number">Step {step.id}</div>
                  <div className="step-title">{step.title}</div>
                </div>
                {index < steps.length - 1 && <div className="step-line"></div>}
              </div>
            ))}
          </div>

          <div className="form-card">
            {currentStep === 1 && (
              <div className="form-step">
                <h2>Property Details</h2>
                <p className="step-description">Tell us about your property type and basic information</p>

                <div className="form-group">
                  <label>Purpose</label>
                  <div className="radio-group">
                    <label className="radio-label">
                      <input
                        type="radio"
                        name="purpose"
                        value="sell"
                        checked={formData.purpose === 'sell'}
                        onChange={(e) => handleInputChange('purpose', e.target.value)}
                      />
                      <span>For Sale</span>
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        name="purpose"
                        value="rent"
                        checked={formData.purpose === 'rent'}
                        onChange={(e) => handleInputChange('purpose', e.target.value)}
                      />
                      <span>For Rent</span>
                    </label>
                  </div>
                </div>

                <div className="form-group">
                  <label>Property Type *</label>
                  <select
                    value={formData.propertyType}
                    onChange={(e) => handleInputChange('propertyType', e.target.value)}
                    required
                  >
                    <option value="">Select property type</option>
                    {propertyTypes.map(type => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Property Title *</label>
                  <input
                    type="text"
                    placeholder="e.g., Luxury 5 Bedroom House in DHA"
                    value={formData.title}
                    onChange={(e) => handleInputChange('title', e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Price (PKR) *</label>
                  <input
                    type="number"
                    placeholder="e.g., 15000000"
                    value={formData.price}
                    onChange={(e) => handleInputChange('price', e.target.value)}
                    required
                  />
                </div>
              </div>
            )}

            {currentStep === 2 && (
              <div className="form-step">
                <h2>Location & Size</h2>
                <p className="step-description">Provide property location and size details</p>

                <div className="form-group">
                  <label>City *</label>
                  <select
                    value={formData.city}
                    onChange={(e) => handleInputChange('city', e.target.value)}
                    required
                  >
                    <option value="">Select city</option>
                    {cities.map(city => (
                      <option key={city} value={city}>{city}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Location *</label>
                  <input
                    type="text"
                    placeholder="e.g., DHA Phase 6, Block A"
                    value={formData.location}
                    onChange={(e) => handleInputChange('location', e.target.value)}
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Area Size *</label>
                    <input
                      type="number"
                      placeholder="e.g., 500"
                      value={formData.area}
                      onChange={(e) => handleInputChange('area', e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Unit</label>
                    <select
                      value={formData.areaUnit}
                      onChange={(e) => handleInputChange('areaUnit', e.target.value)}
                    >
                      <option value="sqft">Square Feet</option>
                      <option value="sqyd">Square Yards</option>
                      <option value="marla">Marla</option>
                      <option value="kanal">Kanal</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Bedrooms</label>
                    <input
                      type="number"
                      placeholder="e.g., 5"
                      value={formData.bedrooms}
                      onChange={(e) => handleInputChange('bedrooms', e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label>Bathrooms</label>
                    <input
                      type="number"
                      placeholder="e.g., 6"
                      value={formData.bathrooms}
                      onChange={(e) => handleInputChange('bathrooms', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}

            {currentStep === 3 && (
              <div className="form-step">
                <h2>Features & Photos</h2>
                <p className="step-description">Add property features and upload photos</p>

                <div className="form-group">
                  <label>Description *</label>
                  <textarea
                    rows="6"
                    placeholder="Describe your property, its features, and surrounding area..."
                    value={formData.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Features</label>
                  <div className="features-grid">
                    {features.map(feature => (
                      <label key={feature} className="feature-checkbox">
                        <input
                          type="checkbox"
                          checked={formData.features.includes(feature)}
                          onChange={() => handleFeatureToggle(feature)}
                        />
                        <span>{feature}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label>Photos</label>
                  <div className="upload-area">
                    <ImageIcon size={48} color="#636e72" />
                    <p>Drag & drop photos here or click to upload</p>
                    <span className="upload-note">Upload up to 20 photos (JPG, PNG)</span>
                    <button type="button" className="btn-upload">Choose Files</button>
                  </div>
                </div>
              </div>
            )}

            {currentStep === 4 && (
              <div className="form-step">
                <h2>Contact Information</h2>
                <p className="step-description">Provide your contact details for potential buyers</p>

                <div className="form-group">
                  <label>Your Name *</label>
                  <input
                    type="text"
                    placeholder="Full Name"
                    value={formData.contactName}
                    onChange={(e) => handleInputChange('contactName', e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Phone Number *</label>
                  <input
                    type="tel"
                    placeholder="+92 300 1234567"
                    value={formData.contactPhone}
                    onChange={(e) => handleInputChange('contactPhone', e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Email Address *</label>
                  <input
                    type="email"
                    placeholder="your.email@example.com"
                    value={formData.contactEmail}
                    onChange={(e) => handleInputChange('contactEmail', e.target.value)}
                    required
                  />
                </div>

                <div className="summary-box">
                  <h3>Summary</h3>
                  <div className="summary-grid">
                    <div className="summary-item">
                      <span className="summary-label">Property Type:</span>
                      <span className="summary-value">{formData.propertyType || 'Not set'}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Purpose:</span>
                      <span className="summary-value">{formData.purpose === 'sell' ? 'For Sale' : 'For Rent'}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Price:</span>
                      <span className="summary-value">PKR {formData.price ? parseInt(formData.price).toLocaleString() : 'Not set'}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Location:</span>
                      <span className="summary-value">{formData.location || 'Not set'}, {formData.city || 'Not set'}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="form-actions">
              {currentStep > 1 && (
                <button type="button" className="btn-secondary" onClick={prevStep}>
                  Previous
                </button>
              )}
              {currentStep < 4 ? (
                <button type="button" className="btn-primary" onClick={nextStep}>
                  Next Step
                </button>
              ) : (
                <button type="button" className="btn-primary" onClick={handleSubmit}>
                  Submit Listing
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default SellProperty;
